import VData from './VData';
export { VData };
export default VData;
//# sourceMappingURL=index.js.map